var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvatar = function SvgIconAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_avatar_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E5E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A3A3A3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#icon_avatar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100c-17.98 0-33.333-2.164-33.333-10.832C16.667 80.502 31.923 72.5 50 72.5c17.98 0 33.333 7.924 33.333 16.59C83.333 97.756 68.077 100 50 100M50.002 60.001c9.204 0 16.665-7.46 16.665-16.665s-7.46-16.668-16.665-16.668-16.668 7.464-16.668 16.668c-.032 9.174 7.377 16.634 16.55 16.665z"
  }))));
};
export default SvgIconAvatar;